import { useCallback } from 'react';
import {
  useCart,
  CartVersion,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName,
  UpdateCartMutation
} from '../../hooks/useCart';
import { useCountry } from '../CountrySelector';

export const getInvalidCodeMessage = (data?: UpdateCartMutation | null) => {
  const error = data?.updateCart.data[0].attributes.error;
  return error?.type.name === 'Invalid Coupon' ? error.message : null;
};

export const useGiftCode = () => {
  const { cart } = useCart();
  const { country } = useCountry();
  const [updateCart, { data, error, loading }] = useUpdateCartMutation();
  const applyGiftCode = useCallback(
    (giftCode: string | null) =>
      updateCart(CartUpdateAction.Gift, {
        [CartUpdatePropertyName.Gift]: giftCode,
        [CartUpdatePropertyName.CountryCode]: country.alpha2Code
      }),
    [country.alpha2Code, updateCart]
  );

  return {
    giftCode: cart.attributes.version === CartVersion.MiniBag ? null : cart.attributes.giftCode,
    invalidCodeMessage: getInvalidCodeMessage(data),
    error,
    loading,
    applyGiftCode
  };
};
